import src from "IMAGE";
export default { src, width: 435, height: 213, blurWidth: 0, blurHeight: 0};
